import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const checkBatchParticipationCompletion = createApiThunk<void, string>(
  "batches/checkBatchParticipationCompletion",
  async (batchId: string, { extra: { adminRepository } }) => {
    return adminRepository!.checkBatchParticipationCompletion(batchId);
  },
);

export const resetCheckBatchParticipationCompletion = createAction("batches/resetCheckBatchParticipationCompletion");
